<template>
  <el-table-column
    prop="location.value"
    label="Terület"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      {{ scope.row.location && scope.row.location.value }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
